// 서버가 HTML 로 내려주는 짧은 제목(예: 레슨 제목 `<p><strong>Lesson 1</strong></p>`)을
// 표 · 확인 창처럼 태그를 그릴 수 없는 자리에 한 줄 글자로 보여 줄 때 씁니다.
export const htmlToPlainText = (html) =>
  String(html ?? '')
    .replace(/<[^>]*>/g, ' ')
    .replace(/&nbsp;/gi, ' ')
    .replace(/&amp;/gi, '&')
    .replace(/&lt;/gi, '<')
    .replace(/&gt;/gi, '>')
    .replace(/\s+/g, ' ')
    .trim()

// HTML 필드(지시사항 · 보기 · 읽기 지문 등)에 화면에 보일 내용이 있는지 봅니다.
// `<p><br></p>` 처럼 태그 · 공백 · &nbsp; · 폭 없는 공백만 있으면 빈 값이고, 이미지 · 영상 같은 미디어 태그가 있으면 내용으로 봅니다.
// 강사 화면 시험 미리보기와 같은 기준입니다.
export const hasHtmlContent = (html) => {
  if (!html) return false
  if (typeof html !== 'string') return !!html
  if (/<(img|video|audio|iframe|embed|object|svg)\b/i.test(html)) return true
  const text = html
    .replace(/<[^>]*>/g, '')
    .replace(/&nbsp;|&#160;|&#xA0;/gi, ' ')
    .replace(/[\u200B-\u200D\uFEFF]/g, '')
    .replace(/\s+/g, '')
  return text.length > 0
}
